export default {
  modules: [
    {
      type: 'TEXT',
      basic: true,
      items: ['TEXT'],
      rowClass: ['row-content'],
      itemClass: [],
      grid: false
    },
    {
      type: 'IMAGE-TEXT',
      basic: true,
      items: ['IMAGE', 'TEXT'],
      rowClass: ['row-content', 'columns'],
      itemClass: ['column'],
      grid: false
    },
    {
      type: 'TEXT-IMAGE',
      basic: true,
      items: ['TEXT', 'IMAGE'],
      rowClass: ['row-content', 'columns'],
      itemClass: ['column'],
      grid: false
    },
    {
      type: 'IMAGE',
      basic: true,
      items: ['IMAGE'],
      rowClass: ['row-content'],
      itemClass: [],
      grid: false
    },
    {
      type: 'IMAGE-IMAGE',
      basic: true,
      items: ['IMAGE', 'IMAGE'],
      rowClass: ['row-content', 'columns'],
      itemClass: ['column'],
      grid: false
    },
    {
      type: 'GRID2N-IMAGE-TEXT',
      basic: true,
      items: ['IMAGE', 'TEXT'],
      rowClass: ['row-content', 'row-content-grid', 'grid2n'],
      itemClass: ['grid-item'],
      grid: true
    },
    {
      type: 'GRID3N-IMAGE-TEXT',
      basic: true,
      items: ['IMAGE', 'TEXT'],
      rowClass: ['row-content', 'row-content-grid', 'grid3n'],
      itemClass: ['grid-item'],
      grid: true
    }
  ]
}
